import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EimDashboardPeriodOption = 'today' | 'currentWeek' | 'currentMonth' | 'currentQuarter' | 'currentYear' | 'custom';

export type EimDashboardFiltersState = {
    periodOption: EimDashboardPeriodOption;
    customPeriodStart: string | null;
    customPeriodEnd: string | null;
    countryCode: string;
    type: 'IN' | 'OUT' | null;
    statusFilters: string[];
};

const initialState: EimDashboardFiltersState = {
    periodOption: 'today',
    customPeriodStart: null,
    customPeriodEnd: null,
    countryCode: '',
    type: null,
    statusFilters: [],
};

const eimDashboardFiltersSlice = createSlice({
    name: 'eimDashboardFilters',
    initialState,
    reducers: {
        setPeriodOption: (state, action: PayloadAction<EimDashboardPeriodOption>) => {
            state.periodOption = action.payload;
            if (action.payload !== 'custom') {
                state.customPeriodStart = null;
                state.customPeriodEnd = null;
            }
        },
        setCustomPeriodRange: (state, action: PayloadAction<{ start: string; end: string } | null>) => {
            state.periodOption = 'custom';
            state.customPeriodStart = action.payload?.start ?? null;
            state.customPeriodEnd = action.payload?.end ?? null;
        },
        setCountryCode: (state, action: PayloadAction<string>) => {
            state.countryCode = action.payload;
        },
        setTileFilters: (state, action: PayloadAction<{ type: 'IN' | 'OUT' | null; statusFilters: string[] }>) => {
            state.type = action.payload.type;
            state.statusFilters = action.payload.statusFilters;
        },
        resetTileFilters: (state) => {
            state.type = null;
            state.statusFilters = [];
        },
    },
});

export const {
    setPeriodOption,
    setCustomPeriodRange,
    setCountryCode,
    setTileFilters,
    resetTileFilters,
} = eimDashboardFiltersSlice.actions;

export default eimDashboardFiltersSlice.reducer;
